import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ValidatorForm } from "react-form-validator-core";
import moment from "moment";
import Header from "../../layout/Header";
import { getDate, selectValueGetter } from "../../../../utils/helper";
import TextValidator from "../../partial/TextValidator";
import { decrypt } from "../../../../utils/encodingdecoding";

import SelectValidator from "../../partial/SelectValidator";
import { generateQRTemplate, getQRTemplateData, updateQRTemplate } from "../../../../components/pages/campaigns/services";
import { getPromotion } from "../../../../actions/auth";
import { backIcon2 } from "../../../../Image/Index";
import { adminEmail, arjunMerchantId, starblazeMerchantId } from "../../../../utils";

const QRCodeSupron = () => {
    const Id = localStorage.getItem("Id")
    const userEmail = localStorage.getItem("email")
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState([]);
    const [subCategoryOption, setSubCategoryOption] = useState([]);
    const [productIdOption, setProductIdOption] = useState([]);
    const [allData, setAllData] = useState([]);
    const [valueTypeOption] = useState(decrypt(Id) === starblazeMerchantId ? [
        { value: "PreLoadedValue", label: "Pre Loaded Value" },
    ] : [
        { value: "NoValue", label: "No Value" },
        { value: "PreLoadedValue", label: "Pre Loaded Value" },
    ]);
    const [typeOption] = useState([
        { value: "Distributor", label: "Distributor" },
        { value: "Retailer", label: "Retailer" },

    ]);
    const [qrTypeOption] = useState([
        { value: "Item", label: "Item" },
        { value: "Box", label: "Box" },
    ])
    const [loader, setLoader] = useState(false);
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const isAdmin = decrypt(userEmail) === adminEmail || decrypt(Id) === arjunMerchantId

    const initialState = {
        valueType: decrypt(Id) === starblazeMerchantId ? "PreLoadedValue" : "",
        value: "",
        quantity: "",
        status: false,
        productId: "",
        variant: "",
        productName: null,
        packagingSize: "",
        category: null,
        subCategory: null,
        type: decrypt(Id) === starblazeMerchantId ? "Retailer" : "",
        QRCodetype: decrypt(Id) === starblazeMerchantId ? "Box" : "",
        redemptionLimitType: false,
        redemptionLimitCount: "",
        issueDate: "",
        expiryDate: "",
        updatedBy: "",
        readOnly: false,
        batchNo: "",
        id: "",
        createdDate: "",
        updatedDate: "",
        createdBy: "",
        totalQRCodeCount: "",
        templateName: "",
        lastGenerateVoucherCount: ""

    };
    const [state, setState] = useState(initialState);
    const [dateErr, setDateErr] = useState(false);

    // useEffect(() => {
    //     let tempEndDate = moment(state.expiryDate).diff(moment(state.issueDate), "days");
    //     if (tempEndDate < 0) {
    //         setDateErr(true);
    //     } else {
    //         setDateErr(false);
    //     }
    // }, [state.issueDate, state.expiryDate]);

    useEffect(() => {
        if (code) {
            const fetchTemplate = async () => {
                try {
                    setLoader(true)
                    const token = JSON.parse(localStorage.getItem("token_gen"));
                    const res = await getQRTemplateData(token?.access_token, code)
                    if (res.message === "Success") {
                        const data = res?.data?.[0]
                        setState((prev) => ({
                            ...prev,
                            valueType: data?.valueType,
                            value: data?.value,
                            quantity: data?.quantity,
                            status: data?.status === "Active" ? true : false,
                            productId: data?.productId,
                            variant: data?.others?.variant,
                            productName: data?.productName,
                            packagingSize: data?.others?.packagingSize,
                            category: data?.others?.categoryName,
                            subCategory: data?.others?.subCategoryName,
                            type: data?.type,
                            QRCodetype: data?.QRCodetype,
                            redemptionLimitType: data?.redemptionLimitType === "OneTime" ? false : true,
                            redemptionLimitCount: data?.redemptionLimitCount || 0,
                            issueDate: data?.issueDate || data?.issueDate,
                            expiryDate:
                                data?.expiryDate.includes("2050")
                                    ? ""
                                    : data?.expiryDate,
                            updatedBy: data?.updatedBy,
                            readOnly: true,
                            batchNo: data?.others?.subCategory,
                            id: data?.id,
                            code: data?.code,
                            createdDate: data?.createdDate,
                            updatedDate: data?.updatedDate,
                            createdBy: data?.createdBy,
                            totalQRCodeCount: data?.totalQRCodeCount,
                            templateName: data?.templateName,
                            lastGenerateVoucherCount: data?.lastGenerateVoucherCount || 0
                        }))
                    }

                } catch (err) {

                } finally {
                    setLoader(false)
                }
            }

            fetchTemplate()
        }
    }, [code])

    const fetchOffer = async () => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const Id = decrypt(localStorage.getItem("Id"));
        try {
            const res = await getPromotion(token?.access_token, Id);
            setAllData(res?.data);
            const categories = res?.data.map((item) => item.category);
            const uniqueCategories = [...new Set(categories)];
            const categoryOptions = [
                { value: "", label: "Select" },
                ...uniqueCategories.map((cat) => ({
                    value: cat,
                    label: cat,
                })),
            ];
            setResponseData(categoryOptions);
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        if (state.category) {
            const filteredSubCategories = allData
                .filter((item) => item.category === state.category)
                .map((item) => ({
                    value: item['subCategory'],
                    label: item['subCategory'],
                }));
            const uniqueSubCategories = [
                { value: "", label: "Select" },
                ...new Map(filteredSubCategories.map((item) => [item.value, item])).values(),
            ];
            setSubCategoryOption(uniqueSubCategories);
        } else {
            setSubCategoryOption([]);
        }
    }, [state.category, allData, state.subCategory]);

    useEffect(() => {
        if (state.category) {
            const filteredSubCategories = allData
                .filter((item) => item['subCategory'] === state.subCategory)
                .map((item) => ({
                    value: item['product_Description'],
                    label: item['product_Description'],
                    points: item["points"],
                    productId: item["productID"],
                    variant: item["Variant"],
                    packing_Size: item["packing_Size"]
                }));
            const uniqueSubCategories = [
                { value: "", label: "Select" },
                ...new Map(filteredSubCategories.map((item) => [item.value, item])).values(),
            ];
            setProductIdOption(uniqueSubCategories);
        } else {
            setProductIdOption([]);
        }
    }, [state.subCategory, allData]);

    useEffect(() => {
        fetchOffer();
    }, []);

    useEffect(() => {
        if (code && productIdOption.length > 0 && state.productName) {
            const matched = productIdOption.find(
                (item) => item.value === state.productName
            );

            if (matched) {
                setState((prev) => ({
                    ...prev,
                    productName: matched.value,
                }));
            }
        }
    }, [productIdOption, code]);

    const handleKeyDown = (e) => {
        const allowedKeys = [
            "Backspace",
            "ArrowLeft",
            "ArrowRight",
            "Delete",
            "Tab",
            "Ctrl",
        ];

        if (e.ctrlKey && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) {
            return;
        }

        if (e.key === " ") {
            e.preventDefault();
            return;
        }

        if (allowedKeys.includes(e.key)) {
            return;
        }

        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault();
        }
    };
    const onSelectChange = (e, name) => {
        const temp = e?.value === "" ? null : e?.value;
        setState((prevState) => ({
    ...prevState,
    [name]: temp,
    ...(name === "category" && {
        subCategory: null,
    productName: null,
    productId: "",
    variant: "",
    packagingSize: "",
    value: "",
    readOnly: false,
    }),
    ...(name === "subCategory" && {
        productName: null,
        productName: null,
    productId: "",
    variant: "",
    packagingSize: "",
    value: "",
    readOnly: false,
    }),
}));
        if (name === "productName") {

            const details = productIdOption.find((ele) => ele.value === temp);
            setState((prev) => ({
                ...prev,
                value: details ? details.points : "",
                productId: details?.productId,
                variant: details?.variant,
                packagingSize: details?.packing_Size
                    ? String(Math.round(Number(details.packing_Size)))
                    : details?.packing_Size,
                readOnly: !!details
            }));
        }
    };


    const onChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const handleStatus = () => {
        setState((prevState) => ({
            ...prevState,
            status: !prevState.status,
        }));
    };

    const handleRedemptionLimit = () => {
        setState((prevState) => ({
            ...prevState,
            redemptionLimitType: !prevState.redemptionLimitType,
        }));
    };

    const handleDateTime = (e) => {
        setState((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };

    const handleReset = async () => {
        setState(initialState);
    };
    const onSubmit = async () => {
        if (!dateErr) {
            setLoader(true);
            const token = JSON.parse(localStorage.getItem("token_gen"));
            let body
            const email = localStorage.getItem("email")
            const { value, redemptionLimitCount, readOnly, batchNo, category, subCategory, packagingSize, expiryDate, variant, ...rest } = state;
            body = {
                ...rest,
                status: state.status ? "Active" : "InActive",
                redemptionLimitType: state.redemptionLimitType ? "Multiple" : "OneTime",
                quantity: Number(state.quantity),
                others: {
                    subCategory: batchNo,
                    variant: variant,
                    subCategoryName: subCategory,
                    categoryName: category,
                    packagingSize: packagingSize
                },
                category: subCategory === "MS" ? `M${batchNo}${packagingSize}` : `S${batchNo}${packagingSize}`,
                expiryDate: "2050-05-02",
                ...(state.valueType === "PreLoadedValue" && {
                    value: Number(state.value),
                }),
                ...(state.redemptionLimitType && {
                    redemptionLimitCount: Number(state.redemptionLimitCount),
                }),
            };

            if (code) {
                body = {
                    ...body,
                    discriminator: "QRCodeTemplate",
                    merchantId: [
                        decrypt(Id)
                    ]
                }
                const res = await updateQRTemplate(token?.access_token, state.id, body);
                if (res.message === "Update Success") {
                    swal({
                        position: "center",
                        icon: "success",
                        title: "QR code template update successfully",
                        showConfirmButton: false,
                        timer: 5000,
                    });
                } else {
                    swal({
                        title: " Oops!",
                        text: res.message,
                        icon: "error",
                        button: "oh no!",
                        timer: 5000,
                    });
                }
            } else {
                const res = await generateQRTemplate(token?.access_token, body);
                if (res.message === "Record Created Successfully.") {
                    swal({
                        position: "center",
                        icon: "success",
                        title: "QR code template create successfully",
                        showConfirmButton: false,
                        timer: 5000,
                    });
                } else {
                    swal({
                        title: " Oops!",
                        text: res.message,
                        icon: "error",
                        button: "oh no!",
                        timer: 5000,
                    });
                }
            }

            setState(initialState);
            navigate("/channel-partner/qrcode-template");
            setLoader(false);
        }
    };

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <Header name={"QR Code Template"} />
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__profileSettingsMain">
                        <div className="dashboard__heading">
                            <div className="dashboard__headingLeft">
                                <div className="dashboard__headingBackLink">
                                    <Link to="" onClick={() => navigate(-1)} >
                                        <img src={backIcon2} alt="" />
                                        <div className="dashboard__headingContent">
                                            <h3>QR Code Template</h3>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="dashboard__profileSettingsBox">
                            <ValidatorForm className="customForm customForm_2" onSubmit={onSubmit}>
                                <div className="row">
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Product Category
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <SelectValidator
                                                placeholder="Select"
                                                className="custom-ReactSelect bordered"
                                                name="category"
                                                onChange={(e) => onSelectChange(e, "category")}
                                                options={responseData}
                                                validators={["required"]}
                                                errorMessages={["Please select category"]}
                                                value={selectValueGetter(responseData, state.category) || null}
                                                isDisabled={code && !isAdmin}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Product Sub Category
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <SelectValidator
                                                placeholder="Select"
                                                className="custom-ReactSelect bordered"
                                                name="subCategory"
                                                onChange={(e) => onSelectChange(e, "subCategory")}
                                                options={subCategoryOption}
                                                isDisabled={code && !isAdmin}
                                                 validators={["required"]}
                                                errorMessages={["Please select sub category"]}
                                                value={
                                                    selectValueGetter(subCategoryOption, state.subCategory) || null
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Product Description
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <SelectValidator
                                                placeholder="Select"
                                                className="custom-ReactSelect bordered"
                                                name="productName"
                                                onChange={(e) => onSelectChange(e, "productName")}
                                                options={productIdOption}
                                                isDisabled={code && !isAdmin}
                                                 validators={["required"]}
                                                errorMessages={["Please select product description"]}
                                                value={
                                                    selectValueGetter(productIdOption, state.productName) || null
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">

                                    {decrypt(Id) === starblazeMerchantId && (
                                        <>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div className="form-group withIcon">
                                                    <label>
                                                        Product Id
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <TextValidator
                                                        maxLength="50"
                                                        className="form-control"
                                                        name="productId"
                                                        readOnly={state.readOnly}
                                                        value={state.productId || ""}
                                                        onChange={(e) => onChange(e)}
                                                        onKeyDown={handleKeyDown}
                                                        validators={["required"]}
                                                        errorMessages={["Product Id is required"]}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div className="form-group withIcon">
                                                    <label>
                                                        Variant
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <TextValidator
                                                        maxLength="50"
                                                        className="form-control"
                                                        name="variant"
                                                        readOnly={state.readOnly}
                                                        value={state.variant || ""}
                                                        onChange={(e) => onChange(e)}
                                                        onKeyDown={handleKeyDown}
                                                         validators={["required"]}
                                                        errorMessages={["Variant is required"]}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                                <div className="form-group withIcon">
                                                    <label>
                                                        Packaging Size
                                                        <span style={{ color: "red" }}>*</span>
                                                    </label>
                                                    <TextValidator
                                                        maxLength="50"
                                                        className="form-control"
                                                        name="packagingSize"
                                                        readOnly={state.readOnly}
                                                        value={state.packagingSize || ""}
                                                        onChange={(e) => onChange(e)}
                                                        onKeyDown={handleKeyDown}
                                                         validators={["required"]}
                                                        errorMessages={["Packaging size is required"]}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Batch No
                                                <span style={{ color: "red" }}>*</span>
                                            </label>

                                            <TextValidator
                                                className="form-control"
                                                name="batchNo"
                                                value={state.batchNo}
                                                readOnly={code ? true : false}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/\D/g, "");

                                                    onChange({
                                                        target: {
                                                            name: "batchNo",
                                                            value,
                                                        },
                                                    });
                                                }}
                                                validators={[
                                                    "required",
                                                    "maxStringLength:6",

                                                ]}
                                                errorMessages={[
                                                    "Please enter batch no.",
                                                    "Batch No cannot exceed 6 digits.",
                                                ]}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <div className="form-group">
                                                <label>
                                                    Redemption Limit Type
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <label className="toggle">
                                                    <input
                                                        type="checkbox"
                                                        name="redemptionLimitType"
                                                        checked={state.redemptionLimitType}
                                                        onChange={handleRedemptionLimit}
                                                        disabled={code && !isAdmin}
                                                    />
                                                    <span className="slider"></span>
                                                    <span className="labels" data-on="Multiple" data-off="OneTime"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {state.redemptionLimitType && (
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group withIcon">
                                                <label>
                                                    Redemption Limit Count
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <TextValidator
                                                    maxLength="50"
                                                    className="form-control"
                                                    name="redemptionLimitCount"
                                                    value={state.redemptionLimitCount}
                                                    onChange={(e) => onChange(e)}
                                                    validators={["required"]}
                                                    errorMessages={["Please enter redemption limit count"]}
                                                    onKeyDown={handleKeyDown}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                QR Type
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <SelectValidator
                                                placeholder="Select Type"
                                                className="custom-ReactSelect bordered"
                                                name="type"
                                                value={selectValueGetter(typeOption, state.type) || ""}
                                                options={typeOption}
                                                validators={["required"]}
                                                errorMessages={["Please select type"]}
                                                onChange={(e) => onSelectChange(e, "type")}
                                                isDisabled={code && !isAdmin}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                QRCode Type
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <SelectValidator
                                                placeholder="Select Type"
                                                className="custom-ReactSelect bordered"
                                                name="QRCodetype"
                                                value={selectValueGetter(qrTypeOption, state.QRCodetype) || ""}
                                                options={qrTypeOption}
                                                validators={["required"]}
                                                errorMessages={["Please select QRCode type"]}
                                                onChange={(e) => onSelectChange(e, "QRCodetype")}
                                                isDisabled={code && !isAdmin}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Activation Date
                                                <span style={{ color: "red" }}>*</span>
                                            </label>
                                            <TextValidator
                                                className="form-control"
                                                name="issueDate"
                                                type="datetime-local"
                                                readOnly={code ? true : false}
                                                value={
                                                    state.issueDate
                                                        ? moment(state.issueDate).format("YYYY-MM-DDTHH:mm")
                                                        : ""
                                                }
                                                // min={getDate(new Date(), "YYYY-MM-DD")}
                                                onChange={handleDateTime}
                                                validators={["required"]}
                                                errorMessages={["Please enter activation date"]}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginBottom: "6px",
                                                    flexWrap: "wrap",
                                                    gap: "6px",
                                                }}
                                            >
                                                <label style={{ marginBottom: 0 }}>
                                                    QR Quantity
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>

                                                {state?.lastGenerateVoucherCount > 0 ? <small
                                                    style={{
                                                        fontSize: "11px",
                                                        color: "#795548",
                                                        background: "#fff8e1",
                                                        padding: "3px 8px",
                                                        borderRadius: "4px",
                                                        border: "1px solid #ffe082",
                                                    }}
                                                >
                                                    Last Count: {state?.lastGenerateVoucherCount} |{" "}
                                                    {moment(state.updatedDate).format("DD-MM-YYYY HH:mm")}
                                                </small> : ""}
                                            </div>

                                            <TextValidator
                                                maxLength="50"
                                                className="form-control"
                                                name="quantity"
                                                value={state.quantity}
                                                onChange={(e) => onChange(e)}
                                                validators={["required"]}
                                                errorMessages={["Please enter QR quantity"]}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </div>
                                    {decrypt(Id) !== starblazeMerchantId && <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <div className="form-group">
                                                <label>
                                                    Value Type
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <SelectValidator
                                                    placeholder="Select Type"
                                                    className="custom-ReactSelect bordered"
                                                    name="valueType"
                                                    value={selectValueGetter(valueTypeOption, state.valueType) || ""}
                                                    options={valueTypeOption}
                                                    validators={["required"]}
                                                    errorMessages={["Please select type"]}
                                                    onChange={(e) => onSelectChange(e, "valueType")}
                                                    isDisabled={code}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                    {state.valueType === "PreLoadedValue" && (
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                            <div className="form-group withIcon">
                                                <label>
                                                    Value
                                                    <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <TextValidator
                                                    maxLength="50"
                                                    className="form-control"
                                                    name="value"
                                                    readOnly={state.readOnly || code}
                                                    value={state.value}
                                                    onChange={(e) => onChange(e)}
                                                    validators={["required"]}
                                                    errorMessages={["Please enter value"]}
                                                    onKeyDown={handleKeyDown}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <label>
                                                Expiration Date
                                                {/* <span style={{ color: "red" }}>*</span> */}
                                            </label>
                                            <TextValidator
                                                className="form-control"
                                                name="expiryDate"
                                                type="datetime-local"
                                                readOnly={code ? true : false}
                                                value={
                                                    state.expiryDate
                                                        ? getDate(state.expiryDate, "YYYY-MM-DDTHH:mm")
                                                        : ""
                                                }
                                                onChange={handleDateTime}
                                            // validators={["required"]}
                                            // errorMessages={["Please enter expiration date"]}
                                            />
                                            {/* {dateErr && (
                                                <span style={{ color: "red" }}>
                                                    Expiration date should be greater than activation date
                                                </span>
                                            )} */}
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                                        <div className="form-group withIcon">
                                            <div className="form-group">
                                                <label>Status</label>
                                                <div className="">
                                                    <label className="toggle">
                                                        <input
                                                            type="checkbox"
                                                            name="status"
                                                            checked={state.status}
                                                            onChange={handleStatus}
                                                            disabled={code && !isAdmin}
                                                        />
                                                        <span className="slider"></span>
                                                        <span className="labels" data-on="Active" data-off="Inactive"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div className="button-section">
                                            <button type="submit" className="btn btn-primary">
                                                {code ? "Update" : "Submit"}
                                            </button>
                                            {!code && <button
                                                type="button"
                                                className="btn btn-danger"
                                                onClick={handleReset}
                                            >
                                                Reset
                                            </button>}
                                        </div>
                                    </div>
                                </div>
                            </ValidatorForm>
                        </div>
                    </div>
                </div >
            </div >
        </>
    );
};

export default QRCodeSupron;